<template>
  <div>
    <!-- Includes section -->
    <ul class="list-none paragraph-1 gap-y-3">
      <li class="flex flex-row items-center gap-x-1">
        <Check class="size-4 shrink-0 self-start mt-[3px]" />
        <div>Everything in Free and Annual plan</div>
      </li>
    </ul>

    <!-- Features section -->
    <ul class="list-none mt-3 paragraph-1 gap-y-3">
      <!-- Paragraphs feature -->
      <li>
        <div class="flex align-baseline">
          <Plus class="fill-primary size-4 inline-block mr-2 shrink-0" />
          <div class="gap-y-3">
            <p v-for="(paragraph, index) in paragraphs" :key="`plus-paragraph-${index}`">
              {{ paragraph }}
            </p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import Check from '@/components/SVGS/BrandIcons/16px/tick.svg'
import Plus from '@/components/SVGS/BrandIcons/16px/add.svg'

const paragraphs = [
  'One scheduled call with Otivo support (up to 30 minutes)',
  'This call is with our support team — not a financial adviser — to answer your questions and show you how to get the best from the platform. And for quick help, Ask Otivo is always on, 24/7',
]
</script>
